export enum RADIOFIELD_SIZES {
    SM = 'sm',
    MD = 'md',
}

export { VALIDATION_TYPES as RADIOFIELD_VALIDATION_TYPES } from '../constants';
